module.exports = __webpack_public_path__ + "static/media/mollo_2.f9af2893.png";